/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetEuOrganizationDisplaySettingResponseDataFromJSON, GetEuOrganizationDisplaySettingResponseDataToJSON } from './GetEuOrganizationDisplaySettingResponseData';
export function GetEuOrganizationDisplaySettingResponseFromJSON(json) {
    return GetEuOrganizationDisplaySettingResponseFromJSONTyped(json, false);
}
export function GetEuOrganizationDisplaySettingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetEuOrganizationDisplaySettingResponseDataFromJSON(json['data'])
    };
}
export function GetEuOrganizationDisplaySettingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetEuOrganizationDisplaySettingResponseDataToJSON(value.data)
    };
}
